<template>
  <div id="rate-filler" class="white-bg pad5">
    <mai-modal v-if="infillService !== null" :title="'Create Infill (' + infillService + ')'" @close="infillService = null">
      <preferences
        slot="content"
        preference-classes="col-xs-12"
        :display-party="displayParty"
        :use-provided-services="true"
        :allow-add="false"
        :load-on-mount="false"
        :provided-services="providedServices"
        :allow-delete="false"
        @toggle-save-button="toggleSaveButton"
      />
      <div slot="footer">
        <div class="btn btn-success sq" :class="[ isValid ? 'valid' : 'disabled', '' ]" @click="addService">Save</div>
        <div class="btn btn-danger sq" @click="infillService = null">Close</div>
      </div>
    </mai-modal>
    <div v-if="routeChoice === null" class="available-routes">
      <blockquote>Please select your desired route in order to progress the filling process</blockquote>
      <div class="route-choice-option" v-for="route in routes" @click="selectRoute(route)">
        <div v-for="service in getRoutesAndSpacers(route)">
          <p v-if="service !== 'SPACER'">
            {{ service }}
            <span class="badge" data-toggle="tooltip" title="Number of available rates">{{ getServiceCount(service) }}</span>
          </p>
          <i v-else class="fa fa-chevron-right"></i>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="btn btn-primary sq" @click="routeChoice = null">Back</div>
      <div class="btn btn-success sq" @click="showRoute">Check</div>
      <blockquote>Your selected Route consists of the following Services</blockquote>
      <div class="route-choice-selections">
        <div class="route-choice-selection" v-for="service in routeChoice">
          <h3 class="text-center">{{ service }}</h3>
          <div class="route-choice-selection-info">
            <p class="text-center" v-if="!routeChoiceSelections[service]">No selection made; please see below</p>
            <div v-else>
              <p class="text-center">{{ getLocationFromRate(routeChoiceSelections[service], 'origin') }}</p>
              <i class="fa fa-chevron-down text-center"></i>
              <p class="text-center">{{ getLocationFromRate(routeChoiceSelections[service], 'destination') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="service-rate-options" v-for="service in routeChoice">
        <hr class="hr-text" :data-content="service + ' Rates'"/>
        <div class="clearfix">
          <div class="btn btn-primary pull-right sq" @click="addRate(service)">
            Fill Rate
          </div>
        </div>
        <div
          class="service-rate-option shadow clearfix row row-eq-height"
          v-for="rate in getServices(service)"
          @click="routeChoiceSelections[service] = rate"
        >
          <div class="col-xs-8 col-sm-10">
            <div class="service-rate-locations">
              <h4>{{ getLocationFromRate(rate, 'origin') }}</h4>
              <i class="fa fa-chevron-right"></i>
              <h4>{{ getLocationFromRate(rate, 'destination') }}</h4>
            </div>
            <div class="service-rate-provider">
              Provider: {{ rate.serviceProviderName }}
            </div>
            <div class="service-rate-tariff">
              Tariff: {{ rate.tariff }}
            </div>
          </div>
          <div class="col-xs-4 col-sm-2 service-rate-cost">
            <div>{{ rate.amount }}</div>
            <div>{{ rate.currency }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MaiModal from '../../../components/MaiModal'
  import Preferences from './Preferences'
  import event from '../../../event'
  export default {
    name: 'RateFiller',
    components: {
      Preferences,
      MaiModal
    },
    props: {
      routes: {
        type: Array,
        required: true
      },
      services: {
        type: Array,
        required: true
      },
      rateRequest: {
        type: Object,
        required: true,
        default: () => ({
          OriginTown: null,
          OriginState: null,
          OriginCountry: null,
          DestinationTown: null,
          DestinationState: null,
          DestinationCountry: null
        })
      }
    },
    data () {
      return {
        routeChoice: null,
        infillService: null,
        providedServices: [],
        routeChoiceSelections: {},
        isValid: false
      }
    },
    computed: {
      routeChoiceServices () {
        return this.routeChoice && this.routeChoice.join(', ')
      },
      serviceBuilderObject () {
        return this.providedServices && this.providedServices[0]
      },
      rateRequestOrigin () {
        return this.rateRequest && (this.rateRequest.OriginTown || this.rateRequest.OriginState || this.rateRequest.OriginCountry)
        ? {
          name: this.rateRequest.OriginTown,
          subdivision: this.rateRequest.OriginState,
          country: {
            code: this.rateRequest.OriginCountry
          }
        }
        : null
      },
      rateRequestDestination () {
        return this.rateRequest && (this.rateRequest.DestinationTown || this.rateRequest.DestinationState || this.rateRequest.DestinationCountry)
          ? {
            name: this.rateRequest.DestinationTown,
            subdivision: this.rateRequest.DestinationState,
            country: {
              code: this.rateRequest.DestinationCountry
            }
          }
          : null
      }
    },
    methods: {
      getRoutesAndSpacers (route) {
        const arr = []
        route.forEach(svc => {
          arr.push(svc)
          arr.push('SPACER')
        })
        arr.pop()
        return arr
      },
      showRoute () {
        let hasRoute = true
        let from = null
        let to = null
        this.routeChoice.forEach(service => {
          if (hasRoute) {
            const serviceFrom = this.getLocation(service, 'origin')
            const serviceTo = this.getLocation(service, 'destination')
            if (from === null && to === null && serviceFrom !== null && serviceTo !== null) {
              /* NoOp */
            } else if (from !== null && to !== null && to !== serviceFrom) {
              hasRoute = false
            } else if (serviceFrom === null || serviceTo === null) {
              hasRoute = false
            }
            from = serviceFrom
            to = serviceTo
          }
        })
        if (hasRoute) {
          event.$emit('toast', { message: 'Route Filled; Optimizing Now', type: 'success' })
          this.$emit('rate-filled', Object.values(this.routeChoiceSelections).filter(obj => obj.manualLoad))
        } else {
          event.$emit('toast', { message: 'Route not connected - please review', type: 'warning' })
        }
        // @todo - populate manualLoad Rates as Preferences and re send rate request
      },
      getLocation (service, prefix) {
        const selection = this.routeChoiceSelections[service]
        return this.getLocationFromRate(selection, prefix)
      },
      getLocationFromRate (rate, prefix) {
        return rate && `${rate[prefix + 'Town']}, ${rate[prefix + 'State'] || ''}, ${rate[prefix + 'Country']}`
      },
      selectRoute (route) {
        const object = {}
        route.forEach(service => { object[service] = null })
        this.$set(this, 'routeChoiceSelections', object)
        this.routeChoice = route
      },
      addService () {
        if (this.isValid) {
          const service = {
            service: this.infillService,
            serviceProviderCode: this.serviceBuilderObject && this.serviceBuilderObject.provider && this.serviceBuilderObject.provider.code,
            serviceProviderName: this.serviceBuilderObject && this.serviceBuilderObject.provider && this.serviceBuilderObject.provider.name,
            originTown: this.serviceBuilderObject && this.serviceBuilderObject.fromLocation && this.serviceBuilderObject.fromLocation.name,
            originState: this.serviceBuilderObject && this.serviceBuilderObject.fromLocation && this.serviceBuilderObject.fromLocation.subdivision,
            originCountry: this.serviceBuilderObject && this.serviceBuilderObject.fromLocation && this.serviceBuilderObject.fromLocation.country && this.serviceBuilderObject.fromLocation.country.code,
            destinationTown: this.serviceBuilderObject && this.serviceBuilderObject.toLocation && this.serviceBuilderObject.toLocation.name,
            destinationState: this.serviceBuilderObject && this.serviceBuilderObject.toLocation && this.serviceBuilderObject.toLocation.subdivision,
            destinationCountry: this.serviceBuilderObject && this.serviceBuilderObject.toLocation && this.serviceBuilderObject.toLocation.country && this.serviceBuilderObject.toLocation.country.code,
            amount: this.serviceBuilderObject && this.serviceBuilderObject.Amount,
            currency: this.serviceBuilderObject && this.serviceBuilderObject.Currency && this.serviceBuilderObject.Currency.code,
            note: this.serviceBuilderObject && this.serviceBuilderObject.note,
            tariff: null,
            manualLoad: true
          }
          this.$emit('add-service', service)
          const infillService = this.infillService
          this.infillService = null
          this.$nextTick(() => {
            this.routeChoiceSelections[infillService] = service
          })
        } else {
          event.$emit('toast', { type: 'warning', message: 'Complete all required fields before saving' })
        }
      },
      generateFromLocation (_service) {
        const i = this.routeChoice.findIndex(service => service === _service)
        if (i > 0) {
          const priorService = this.routeChoice[i - 1]
          const serviceRate = this.routeChoiceSelections[priorService]
          if (serviceRate) {
            return {
              name: serviceRate.destinationTown,
              subdivision: serviceRate.destinationState,
              country: { code: serviceRate.destinationCountry }
            }
          }
        } else if (i === 0) {
          return this.rateRequestOrigin
        }
        return null
      },
      generateToLocation (_service) {
        const i = this.routeChoice.findIndex(service => service === _service)
        const lastIndex = this.routeChoice.length - 1
        if (i > -1 && i !== lastIndex) {
          const nextService = this.routeChoice[i + 1]
          const serviceRate = this.routeChoiceSelections[nextService]
          if (serviceRate) {
            return {
              name: serviceRate.originTown,
              subdivision: serviceRate.originState,
              country: { code: serviceRate.originCountry }
            }
          }
        } else if (i === lastIndex) {
          return this.rateRequestDestination
        }
        return null
      },
      addRate (service) {
        this.providedServices = [
          {
            name: service,
            code: service,
            fromLocation: this.generateFromLocation(service),
            toLocation: this.generateToLocation(service),
            provider: null,
            Amount: null,
            Currency: {}
          }
        ]
        this.infillService = service
        this.isValid = false
      },
      getServiceCount (_service) {
        return this.getServices(_service).length
      },
      getServices (_service) {
        return this.services.filter(({service}) => service === _service)
      },
      getRateLabel ({ originTown, originState, originCountry,
                      destinationTown, destinationState, destinationCountry,
                      serviceProviderName, amount, currency
      }) {
        return `${originTown} (${originCountry}) to ${destinationTown} (${destinationCountry}), ${serviceProviderName}, ${amount} ${currency}`
      },
      displayParty (p) {
        return `${p.name}, ${p.code}`
      },
      toggleSaveButton (isValid) {
        this.isValid = isValid
      }
    }
  }
</script>
<style>
  .white-bg {
    background: #fff;
  }
  .pad5 {
    padding: 5px;
  }
  .route-choice-option {
    border: #eee dashed 1px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }
  .route-choice-selections {
    display: flex;
    justify-content: space-between;
  }
  .route-choice-selection {
    flex: 1;
    border: #eee dashed 1px;
    padding: 5px;
    cursor: pointer;
  }
  .service-rate-locations {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .service-rate-cost {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-left: solid 1px #eee;
  }
  .service-rate-option {
    margin: 0 0 10px 0 !important;
    cursor: pointer;
  }
  .route-choice-selection-info p {
    margin-bottom: 0;
  }
  .route-choice-selection-info i {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/modules/quote/components/RateFiller.vue